export const CONTACT_EMAIL = "contact@influx-app.com";
export const INSTA_LINK = "https://www.instagram.com/influx.fr/";
export const FB_LINK = "https://www.facebook.com/profile.php?id=61551012603055";

export const INFLUENCER_PREMIUM_MONTHLY = 9;
export const INFLUENCER_PREMIUM_ANNUALLY = 79;

export const COMPANY_PREMIUM_MONTHLY = 49;
export const COMPANY_PREMIUM_SIX_MONTHS = 229;
export const COMPANY_PREMIUM_ANNUALLY = 349;
